import React from "react";

export const menuState = {
  isHamburgerMenuOpen: false,
  setIsHamburgerMenuOpen: (state: boolean) => {},
};
export const MenuContext = React.createContext(menuState);
